import { apiPost } from "./client";

export const setManualInvoiceAccountingRegistration = async (
  token: string,
  invoiceId: string,
  registered: boolean,
  workspaceId?: string,
) => {
  const suffix = registered ? "" : "/revert";
  const response = await apiPost(
    token,
    `/api/invoices/${invoiceId}/accounting/manual-registration${suffix}`,
    {},
    workspaceId,
  );
  return response.data;
};
